import React, { Component } from "react";
import { ensureLoggedIn } from '../../../common/loginGate'
import {
  Card,
  WhiteSpace,
  WingBlank,
  List,
  Toast,
  InputItem,
  Icon,
} from "antd-mobile";
import get from "lodash/get";
import difference from "lodash/difference";
import map from "lodash/map";
import includes from "lodash/includes";
import moment from "moment";
import debounce from "lodash/debounce";
import findIndex from "lodash/findIndex";
import "./styles/overwrite.css";
import styled from "styled-components";
import CommentInput from "./commentInput";
import { CommentHeader } from "./CommentHeader";

import { getPatientIdFromUrl } from "../../../utils";
import { CommentFIxed } from "./commentFIxed";

const NameLabel = ({ userName, repliedUsername }) => {
  return (
    <NameStyled>
      <span className="name" >{userName}</span>
      <span
        className="reply"
        style={{
          fontFamily: "PingFang SC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif;",
        }}
      >
        回复
      </span>
      <span className="last-name name">{repliedUsername}:</span>
    </NameStyled>
  );
};

class Comment extends Component {
  state = {
    comments: [],
    showInput: false,
    replyType: "",
    user: {},
    _id: "",
    commentsCount: 0,
    modal: false,
    isClean: false,
    isShowDeleteBtn: false,
  };
  componentWillReceiveProps(nextProps) {
    if (!nextProps.blogs.loading) {
      let comments = get(nextProps, "blogs.blogs[0].comments", []) || [];
      const commentsCount = get(nextProps, "blogs.blogs[0].commentCount");
      const patientId = getPatientIdFromUrl(this.props);
      comments =
        comments.length != 0
          ? [...comments].sort((a, b) => {
              return b.votes.length - a.votes.length;
            })
          : [];
      this.setState({ patientId, comments, commentsCount });
    }
  }
  componentDidMount() {
    const isShare = get(this.props, "isShare");
    if (isShare) {
      const comments = get(this.props, "blogs.blogs[0].comments");
      this.setState({ comments });
    }
  }
  commentVotesClick = (commentId) => {
    // 先确认已登录再动界面：否则会先 +1、请求被拒后回退、最后才弹登录框
    ensureLoggedIn().then(() => this.applyVotesClick(commentId), () => {})
  };

  applyVotesClick = (commentId) => {
    let comments = [...this.state.comments];
    const index = findIndex(comments, { _id: commentId });
    if (index >= 0) {
      let votes = get(comments, [index, "votes"], []);
      const pIndex = findIndex(votes, (v) => v === this.state.patientId);
      if (pIndex >= 0) {
        votes = difference(votes, [this.state.patientId]);
      } else {
        votes = [...votes, this.state.patientId];
      }
      comments.splice(index, 1, { ...comments[index], votes });
      this.handleVotesClick(commentId);
      this.setState({ comments });
    }
  };
  showInput = () => {
    this.setState({
      showInput: true,
    });
  };
  closeCommentInput = () => {
    this.setState({
      showInput: false,
    });
  };
  handleVotesClick = debounce((commentId) => {
    const mutate = this.props.updateBlogVote;
    const blog = get(this.props, "blogs.blogs[0]");
    const type = "voteComment";
    const patientId = getPatientIdFromUrl(this.props);
    const systemType = get(this.props, "match.params.systemType", "BG");
    const variables = {
      blogId: blog._id,
      systemType,
      type,
      patientId,
      commentId,
    };
    mutate({
      variables,
    });
  }, 500);

  clickShowInput = (user, _id, type) => {
    this.setState({
      user,
      _id,
      showInput: true,
      replyType: type,
    });
  };
  /**
   * 判断是否为全面屏
   */
  judgeBigScreen() {
    const rate = window.screen.height / window.screen.width;
    const limit =
      window.screen.height === window.screen.availHeight ? 1.8 : 1.65;
    return rate > limit ? true : false;
  }
  showModal = (key) => (url, type) => {
    this.setState({
      modal: true,
      url,
      isShowDeleteBtn: type === "commentType" ? false : true,
    });
  };
  onClose = (key) => () => {
    this.setState({
      modal: false,
    });
  };
  handleDeleteImg = () => {
    this.setState({
      modal: false,
      isClean: true,
    });
  };
  handleFlag = () => {
    this.setState({
      isClean: false,
    });
  };
  render() {
    const { patientId, comments, commentsCount, isClean, isShowDeleteBtn } =
      this.state;
    const isShare = get(this.props, "isShare", true);
    const commentElement = map(comments, (comment, i) => {
      if (isShare) {
        while (i > 2) return; // 微信分享最多只展示三条记录
      }
      const { user, createdAt, _id, votes, content } = comment;
      const isVoted = includes(votes, patientId);
      return (
        <div
          key={_id}
          style={{
            padding: "0 14px",
          }}
        >
          <CommentHeader
            commentList={comment}
            onClick={this.clickShowInput}
            clickVotes={this.commentVotesClick}
            isShare={isShare}
            isVoted={isVoted}
            patientId={patientId}
            showModal={this.showModal()}
          />
          {isShare || !get(comment, "secondReplys.length") ? null : ( // 微信分享不展示二级回复
            <CommentContent>
              {comment.secondReplys.map((item) => {
                if (item.showState === false) {
                  if (!includes(item.userName, "医生")) {
                    return null;
                  } else {
                    return <Container>该评论已经被删除</Container>;
                  }
                } else {
                  return (
                    <Container
                      hasBottom={item.commentImage}
                      onClick={
                        isShare
                          ? () => {}
                          : () => this.clickShowInput(item, _id, "second")
                      }
                    >
                      <NameLabel
                        userName={item.userName}
                        repliedUsername={item.beReplyedName}
                      />

                      <span
                        style={{
                          whiteSpace: "pre-wrap",
                          lineHeight: "24px",
                          fontFamily: "PingFang SC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif;",
                        }}
                      >
                        {item.content &&
                          item.content.trim().replace(/(\s){2,}/g, "$1")}
                      </span>
                      {item.commentImage && item.commentImage.length > 0 ? (
                        <BtnContainer
                          onClick={(e) => {
                            e.stopPropagation();
                            this.showModal()(
                              item.commentImage.replace(/http:/, "https:"),
                              "commentType"
                            );
                          }}
                        >
                          <img
                            src={require("./images/showImage.png")}
                            style={{
                              height: 14,
                              width: 16,
                              marginRight: 4,
                              backgroundSize: "100% 100%",
                            }}
                          />
                          查看图片
                        </BtnContainer>
                      ) : null}
                    </Container>
                  );
                }
              })}
              {/* {comment.secondReplys && comment.secondReplys.length > 0 ? (
              <BtnContainer>
                <span>查看更多</span>
              </BtnContainer>
            ) : null} */}
            </CommentContent>
          )}
        </div>
      );
    });
    const isBigScreen = this.judgeBigScreen();
    return (
      <Main>
        <WingBlank
          style={{
            height: "10px",
          }}
          size="lg"
        />
        <div style={{ paddingBottom: isBigScreen ? 34 : 0 }}>
          <div
            style={{
              // padding: "0 14px",
              background: "#fff",
            }}
          >
            <div>
              <div
                id="blog-comment"
                style={{
                  color: "#333333",
                  fontSize: "15px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  padding: "14px 0 10px 14px",
                  fontFamily: "PingFang SC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif",
                  lineHeight: "20px",
                }}
              >{`评论 (${
                isShare
                  ? comments.length > 2
                    ? 3
                    : comments.length
                  : commentsCount
              }条)`}</div>
            </div>
          </div>
          <ListView
            className="comment-list"
            style={{ paddingBottom: 30, backgroundColor: "white" }}
          >
            {commentElement}
          </ListView>
        </div>
        <WhiteSpace size="xl" style={{ height: 33 }} />
        {this.state.showInput ? (
          <CommentInput
            replyType={this.state.replyType}
            user={this.state.user}
            _id={this.state._id}
            clickShowInput={this.showInput}
            closeCommentInput={this.closeCommentInput}
            {...this.props}
            isBigScreen={isBigScreen}
            showModal={this.showModal()}
            handleFlag={this.handleFlag}
            isClean={isClean}
          />
        ) : (
          <CommentFIxed
            replyType={this.state.replyType}
            user={this.state.user}
            _id={this.state._id}
            clickShowInput={this.showInput}
            closeCommentInput={this.closeCommentInput}
            {...this.props}
            isBigScreen={isBigScreen}
            showModal={this.showModal()}
            handleFlag={this.handleFlag}
            isClean={isClean}
          />
        )}
        <AlertMask
          style={this.state.modal ? { display: "block" } : { display: "none" }}
        >
          <CloseBtn>
            <Icon
              type="cross"
              style={{ width: "100%", height: "100%", color: "#fff" }}
              onClick={this.onClose()}
            />
          </CloseBtn>
          <ImageContent>
            <img src={this.state.url} width="70%" />
          </ImageContent>
          {isShowDeleteBtn && (
            <DeleteBtn onClick={this.handleDeleteImg}>删除</DeleteBtn>
          )}
        </AlertMask>
      </Main>
    );
  }
}

export default Comment;
const Main = styled.div``;
const AlertMask = styled.div`
  width: 100%;
  height: calc(100vh);
  background: #000;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  .am-list-line::after {
    height: 0px !important;
  }
`;
const CloseBtn = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #fff;
`;
const DeleteBtn = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  margin-left: -50px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 4px;
  text-align: center;
`;
const ImageContent = styled.div`
  width: 100%;
  height: 300px;
  position: absolute;
  top: 50%;
  margin-top: -150px;
  background: #000;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ListView = styled(List)`
  .am-list-body {
    flex: 1;
    .am-list-item {
      padding-left: 0px;
      .am-list-line {
        padding-right: 0px;
      }
    }
    .am-list-line::after {
      height: 0px !important;
    }
  }
  .am-list-body::after {
    height: 0px !important;
  }
`;
const CommentContent = styled.div`
  position: relative;
  padding: 8px 12px 0px 7px;
  color: rgba(102, 102, 102, 1);
  background: rgba(250, 250, 250, 1);
  font-size: 14px;
  line-height: 17px;
`;
const BtnContainer = styled.div`
  color: rgba(13, 84, 228, 1);
  font-size: 14px;
  display: flex;
  margin-top: 5px;
  line-height: 16px;
`;
const Container = styled.div`
  position: relative;
  padding-bottom: 12px;
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
  line-height: 17px;
`;

const CommentsLabel = styled.span`
  font-size: 14px;
  white-space: pre-wrap;
`;
const NameStyled = styled.div`
  display: inline-block;
  line-height: 24px;
  .name {
    color: rgba(89, 89, 89, 1);
    font-weight: bold;
    font-family: "PingFang SC";
  }
  .reply {
    display: inline;
    margin: 0px 5px;
  }
  .last-name {
    margin-right: 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/modules/knowledge/components/comment.js